/**
 * Module 12 owns the Connections destination. Authenticated feature consumers use this public
 * target instead of copying the router name, so a future route rename stays local to this slice.
 *
 * Keep this module dependency-free: importing the target must not pull the Connections route
 * records or their settings/i18n dependencies into a consumer chunk.
 */
export const CONNECTIONS_ROUTE = { name: 'SettingsConnections' } as const

/** `/settings/slack` (ORP-27946) — linked from the Slack notification channel's webhook form. */
export const SLACK_SETTINGS_ROUTE = { name: 'SlackSettings' } as const
